export const BUG_REPORT_URGENCY_OPTIONS = [
  { value: "minor", label: "Minor" },
  { value: "major", label: "Major" },
  { value: "emergency", label: "Emergency" },
];

export const validateBugReportForm = ({ summary, description }) => {
  const errors = {};
  const trimmedSummary = String(summary || "").trim();
  const trimmedDescription = String(description || "").trim();

  if (!trimmedSummary) {
    errors.summary = "Short summary is required.";
  } else if (trimmedSummary.length < 5) {
    errors.summary = "Summary must be at least 5 characters.";
  } else if (trimmedSummary.length > 200) {
    errors.summary = "Summary must be 200 characters or fewer.";
  }

  if (!trimmedDescription) {
    errors.description = "Description is required.";
  } else if (trimmedDescription.length < 5) {
    errors.description = "Description must be at least 5 characters.";
  } else if (trimmedDescription.length > 10000) {
    errors.description = "Description must be 10000 characters or fewer.";
  }

  return errors;
};

export const buildBugReportContext = () => ({
  path: window.location?.href || "",
  pathname: window.location?.pathname || "",
  userAgent: navigator.userAgent,
  time: new Date().toISOString(),
});

export const createBugReportFormData = ({
  instanceUniqueId,
  summary,
  description,
  urgency,
  files = [],
  context = buildBugReportContext(),
}) => {
  const formData = new FormData();
  formData.append("instanceUniqueId", String(instanceUniqueId || "").trim());
  formData.append("summary", String(summary || "").trim());
  formData.append("description", String(description || "").trim());
  formData.append("urgency", String(urgency || "minor").trim() || "minor");
  formData.append("context", JSON.stringify(context));

  files.forEach((file) => {
    formData.append("files", file);
  });

  return formData;
};
